import angular from 'angular';

/**
 * Modulo per importare file json
 */
const jsonLoaderFactory = function JsonLoaderFactory($rootScope, $q, $http) {
  "ngInject";
  return {
    getJson: function(url) {
      return $q.when($http({
        method: "GET",
        url: url,
        // sovrabbondante
        headers: {
          'Content-type': 'application/json'
        }
      }));
    }
  };
}
export default jsonLoaderFactory;



/** WEBPACK FOOTER **
 ** ./client/app/common/services/tinaba-framework/jsonLoader.factory.js
 **/